import type { V4HSiteId } from "@/data/common/ids";
import type { MaybeRefOrGetter } from "vue";

import { useQuery } from "@tanstack/vue-query";
import { computed, toRef } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";

export function useGetSiteSectionsPlanningQuery(siteId: MaybeRefOrGetter<V4HSiteId>) {
  const v4bClientSdk = useServices().v4b.clientSdk;
  const _siteId = toRef(siteId);

  return useQuery({
    queryKey: SiteProgrammingRangeQueryKeys.findPlanning(_siteId),
    queryFn: async () => v4bClientSdk.siteProgrammingRange.findPlanning(_siteId.value),
    enabled: computed(() => _siteId.value > 0),
  });
}
